import { DrawApi } from '@apply/api';
import { applicationInsights } from '../../../../ApplicationInsights';
import { handleAdminError } from '../../../../common/SharedFunctions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createBudget = async (propertyId: number, isPopulated: boolean) => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);

    const response = await drawApi.addDrawBudget(propertyId, isPopulated);

    if (response.statusCode === 200) {
        return response.result.id;
    } else {
        handleAdminError(new Error('Unable to create draw.'));
    }
};
